import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import Editor from '../../Editor';
import cn from 'classnames';
import { extConfig } from './config';
import GroupAboutBubbleMenu from '../../../menus/GroupAboutBubbleMenu';
import viewerStyles from '../../../Viewer/presets/UserDonations/UserDonations.scss';
import s from './UserDonations.scss';
const UserDonationsEditor = (props)=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
        withinModal: true,
        presetId: "userdonations",
        className: cn(s['root'], viewerStyles['root']),
        extensionConfig: extConfig
    }), (editor, scrollContainer)=>/*#__PURE__*/ React.createElement(GroupAboutBubbleMenu, {
            scrollContainerRef: scrollContainer
        })));
};
UserDonationsEditor.displayName = 'UserDonationsEditor';
export default UserDonationsEditor;

//# sourceMappingURL=UserDonations.js.map